import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonModal,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { close } from 'ionicons/icons';
import { PlanEntitlementKey, User } from '../../api/graphql/generated';
import i18n from '../../i18n';
import { getLocalizedText } from '../../i18n/i18n.utils';
import { logger } from '../../util/logger';
import { CenteredContent } from '../ui/centered-content';
import { Paywall } from './paywall';

interface PaywallModalContentProps {
  user: User | undefined;
  planEntitlementKey: PlanEntitlementKey | undefined;
  onDismiss?: () => void;
}

type PaywallModalProps = Omit<PaywallModalContentProps, 'onDismiss'> &
  Required<Pick<PaywallModalContentProps, 'onDismiss'>> & {
    isOpen: boolean;
  };

const PaywallModal = (props: PaywallModalProps) => {
  const { isOpen, onDismiss } = props;

  return (
    <IonModal isOpen={isOpen} onDidDismiss={onDismiss}>
      <PaywallModalContent {...props} />
    </IonModal>
  );
};

const PaywallModalContent = (props: PaywallModalContentProps) => {
  const { user, planEntitlementKey, onDismiss } = props;

  if (!user) {
    logger.error('Failed to display paywall content. No user exists.', {
      planEntitlementKey,
    });
  }

  return user && planEntitlementKey ? (
    <>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot={'start'} onClick={onDismiss}>
            <IonButton>
              <IonIcon icon={close} size="large" />
            </IonButton>
          </IonButtons>
          <IonTitle>{i18n.t('plan:plan_upgrade')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <Paywall
          user={user}
          planEntitlementKey={planEntitlementKey}
          onBeforeNavigate={onDismiss}
        />
      </IonContent>
    </>
  ) : (
    <IonContent>
      <CenteredContent>
        {getLocalizedText('common:content_unavailable')}
      </CenteredContent>
    </IonContent>
  );
};

export { PaywallModal, PaywallModalContent };
